export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/getup_desktop-6969b9fbc320ef08ceae5444c9c7937a.png";